module.exports = __webpack_public_path__ + "static/media/globe-africa.7ab538c1.svg";